import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
} from 'antd'
import { useState } from 'react'
import { Entity } from '../../../utils/Entities'
import { confirmationRequiredRule, requiredRule } from '../../../utils/rules'
import { timezones } from '../../utils/TimeZoneSelect'
import { Venue } from '../Venue'

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const [showAddressForm, setShowAddressForm] = useState<boolean>(false)

  const venueType = Form.useWatch('type', form)

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item label={'Name'} name="name" rules={[requiredRule()]}>
        <Input max={45} showCount />
      </Form.Item>
      <Form.Item name="type" rules={[requiredRule()]} label={'Type'}>
        <SBAsyncSelect
          entity={Entity.venueType}
          searchFieldName="name"
          allowClear
        />
      </Form.Item>
      {venueType && venueType !== 4 && (
        <Form.Item
          name="venueAuthorization"
          valuePropName="checked"
          rules={[confirmationRequiredRule()]}
        >
          <Card size="small">
            <Checkbox>
              I acknowledge that adding a venue to the <b>Pléthore platform</b>{' '}
              may lead to an adjustment of the <b>annual fees</b>, and I confirm
              that I am duly
              <b> authorized </b> to make this addition.
            </Checkbox>
          </Card>
        </Form.Item>
      )}
      {showAddressForm && (
        <>
          <Row gutter={[16, 16]}>
            <Col span={16}>
              <Form.Item
                label={'Address'}
                rules={[requiredRule()]}
                name={['address', 'label']}
              >
                <Input maxLength={45} showCount />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={'Post code'}
                rules={[requiredRule()]}
                name={['address', 'postCode']}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <Form.Item
                label={'Latitude'}
                rules={[requiredRule()]}
                name={['address', 'latitude']}
              >
                <InputNumber
                  min={-90}
                  max={90}
                  required
                  className="w-full"
                  stringMode
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={'Longitude'}
                rules={[requiredRule()]}
                name={['address', 'longitude']}
              >
                <InputNumber
                  min={-180}
                  max={180}
                  required
                  className="w-full"
                  stringMode
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={'Timezone'}
                rules={[requiredRule()]}
                name={'timezone'}
              >
                <Select
                  options={timezones}
                  showSearch
                  placeholder="Sélectionnez un fuseau horaire"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Button
                danger
                onClick={() => setShowAddressForm(false)}
                block
                style={{ marginTop: 30 }}
              >
                Reset
              </Button>
            </Col>
          </Row>
        </>
      )}

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Venue.Map
            setShowAddressForm={setShowAddressForm}
            showAddressForm={showAddressForm}
          />
        </Col>
      </Row>
    </Form>
  )
}

export default Create
